// Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import NavigationBar from '../component/navigationBar/navigationBar';
import Footer from '../component/section/footer/footer';
import { useUrlLanguageSync } from '../services/LanguageContext';

const Layout = () => {
  // This will sync the language context with the URL parameter
  useUrlLanguageSync();

  return (
    <>
      <NavigationBar />
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;
